import React from 'react';

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-var
  var mountedIds: Record<string, any> = {};
}

type Props = {
  id: string;
};

class Mountpoint extends React.Component<Props> {
  shouldComponentUpdate() {
    return false;
  }

  constructor(props: Props) {
    super(props);
    if (process.env.NODE_ENV === 'development') {
      if (mountedIds[props.id]) {
        console.error(
          'Invariant violation. There can be only one Mountpoint for "%s" ' +
            'mounted at a time.',
          props.id
        );
      }
    }
  }

  componentWillUnmount() {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line webflow/no-delete
      delete mountedIds[this.props.id];
    }
  }

  render() {
    return <div id={this.props.id} style={{position: 'absolute'}} />;
  }
}

export default Mountpoint;
